var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aurora-backdrop",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"blob blob-1"}),_c('div',{staticClass:"blob blob-2"}),_c('div',{staticClass:"blob blob-3"}),_c('div',{ref:"glow",staticClass:"cursor-glow"}),_c('div',{staticClass:"grain"})])
}
var staticRenderFns = []

export { render, staticRenderFns }